export default __webpack_public_path__ + "static/media/lock.d1fa9d63.svg";